import { Button, Form, Input } from 'antd';
import { observer } from 'mobx-react';
import PageHeader from '../../../component/PageHeader';
import { TourPackageCategoryBreadcrumb } from '../../../config/BreadcrumbConfig';
import ListComponent from './components/ListComponent';
import useStore from '../../../store';
import { useEffect, useState } from 'react';
import AddComponent from './components/AddComponent';
import DeleteComponent from './components/DeleteComponent';
import EditComponent from './components/EditComponent';

const TourPackageCategory = observer(() => {
	const [userAddModal, setUserAddModal] = useState(false);
	const [userEditModal, setUserEditModal] = useState(false);
	const [userDeleteModal, setUserDeleteModal] = useState(false);
	const { TOURPACKAGECATEGORY } = useStore();

	const AddUserModal = () => {
		setUserAddModal(true);
	};

	const closeAddModal = () => {
		setUserAddModal(false);
	};

	const openEdit = () => {
		setUserEditModal(true);
	};

	const closeEditModal = () => {
		setUserEditModal(false);
	};

	const openDelete = (data) => {
		setUserDeleteModal(data);
	};

	const closeDeleteModal = () => {
		setUserDeleteModal(false);
	};

	const onSearch = (text) => {
		if (text.length >= 3 || text.length === 0) {
			TOURPACKAGECATEGORY.searchValue = text;
			TOURPACKAGECATEGORY.setupGrid(TOURPACKAGECATEGORY.agGrid);
		}
	};

	useEffect(() => {
		return () => {
			TOURPACKAGECATEGORY.searchValue = '';
		};
	}, []);

	return (
		<div className="mainPageWrap">
			<PageHeader
				className="mainPageHeader"
				title={TourPackageCategoryBreadcrumb.title}
				extra={[
					<Form.Item help={'Write 3 letters to search'} key={1}>
						<Input
							placeholder="Search here"
							onChange={(e) => onSearch(e.target.value)}
						/>
					</Form.Item>,
					<Button
						key={2}
						type="primary"
						className="addBtn"
						onClick={AddUserModal}
					>
						Add Tour Package Category
					</Button>,
				]}
			/>
			<ListComponent
				openEditModal={openEdit}
				openDeleteModal={openDelete}
			/>
			<AddComponent visible={userAddModal} onClose={closeAddModal} />
			<EditComponent visible={userEditModal} onClose={closeEditModal} />
			<DeleteComponent
				visible={userDeleteModal}
				onClose={closeDeleteModal}
			/>
		</div>
	);
});

export default TourPackageCategory;
